
import { setAccountOverview } from "../redux/slices/accountOverviewSlice";
import { setProjects, setLeastPerforming, setTopPerforming, setProjectsUsage, setExclusionUsage } from "../redux/slices/projectsSlice";

class LocalMetrics{
    update(data, dispatch, target){
        dispatch(setAccountOverview({...data.accountOverviewData, target}))
        dispatch(setProjectsUsage({...data.projectsUsage, target}))
        dispatch(setProjects({...data.projectsData, target}))
        dispatch(setLeastPerforming({leastPerforming: data.projectsStats.leastPerforming, target}))
        dispatch(setTopPerforming({topPerforming: data.projectsStats.topPerforming, target}))
        dispatch(setExclusionUsage({...data.exclusionUsage, target}))
    }
}

export default LocalMetrics